import React from 'react';
import Spinner from './Spinner';

/**
 * Table
 * Props:
 *   columns — [{ key, label, render?: (value, row) => JSX, width? }]
 *   data    — array of row objects
 *   loading — shows spinner
 *   emptyText — string shown when data is empty
 *   rowKey  — function or string to get unique key per row (default: uses index)
 */
const Table = ({
  columns  = [],
  data     = [],
  loading  = false,
  emptyText= 'No data found.',
  rowKey,
}) => {
  const getKey = (row, idx) => {
    if (typeof rowKey === 'function') return rowKey(row);
    if (typeof rowKey === 'string')   return row[rowKey];
    return idx;
  };

  return (
    <div className="table-wrapper">
      <table className="table">
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.key} style={col.width ? { width: col.width } : {}}>
                {col.label ?? col.header ?? col.title ?? ''}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan={columns.length}>
                <Spinner />
              </td>
            </tr>
          ) : data.length === 0 ? (
            <tr>
              <td colSpan={columns.length}>
                <div className="table__empty">{emptyText}</div>
              </td>
            </tr>
          ) : (
            data.map((row, idx) => (
              <tr key={getKey(row, idx)}>
                {columns.map((col) => (
                  <td key={col.key}>
                    {col.render
                      ? col.render(row[col.key], row, idx)
                      : row[col.key] ?? '—'}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
